export const agenda = () => {
  const agendas = document.querySelectorAll("[data-agenda]");
  if (!agendas) return;

  const openClass = "module-agenda__agenda-item--open";

  agendas.forEach((agenda) => {
    const agendaItems = agenda.querySelectorAll("[data-agenda-item]");

    agendaItems.forEach((agendaItem) => {
      const trigger = agendaItem.querySelector(
        ".module-agenda__agenda-item-trigger"
      );
      const target = agendaItem.querySelector(
        ".module-agenda__agenda-item-target"
      );

      trigger.addEventListener("click", (e) => {
        if (!agendaItem.classList.contains(openClass)) {
          slideDown(target);
          agendaItem.classList.add(openClass);
        } else {
          slideUp(target);
          agendaItem.classList.remove(openClass);
        }
      });

      trigger.addEventListener("keyup", (e) => {
        if (e.keyCode === 13) {
          trigger.click();
        }
      });
    });

    const agendaAllTrigger = agenda.querySelector("[data-agenda-trigger-all]");
    agendaAllTrigger.addEventListener("click", (e) => {
      e.preventDefault();

      agendaItems.forEach((agendaItem) => {
        const target = agendaItem.querySelector(
          ".module-agenda__agenda-item-target"
        );

        if (!agendaItem.classList.contains(openClass)) {
          slideDown(target);
          agendaItem.classList.add(openClass);
        } else {
          slideUp(target);
          agendaItem.classList.remove(openClass);
        }

        // slideDown(target);
        // agendaItem.classList.add(openClass);
      });
    });
  });

  const slideDown = (elem) => (elem.style.height = `${elem.scrollHeight}px`);
  const slideUp = (elem) => (elem.style.height = "0");
};

document.addEventListener("DOMContentLoaded", agenda());
